<template>
  <div class="ownership-viewer-container">
    <div v-if="!editing" class="ownership-viewer">
      <div v-if="entity.ownerId" class="ownership-section">
        <div class="ownership-section-title">Owner:</div>
        <div class="ownership-section-content">
          <user-short :user-id="entity.ownerId" :show-user-name="true" length="20"></user-short>
        </div>
      </div>
      <div v-if="entity.coOwnerIds.length > 0" class="ownership-section">
        <div class="ownership-section-title">Co-Owners:</div>
        <div class="ownership-section-content">
          <div v-for="coOwnerId in entity.coOwnerIds" :key="coOwnerId">
            <user-short :user-id="coOwnerId" :show-user-name="true" length="20"></user-short>
          </div>
        </div>
      </div>
      <div>
        <button class="btn btn-link manage-owners-button" @click="editOwners">
          Manage Owners
        </button>
      </div>
    </div>
    <ownership-editor
      v-else
      :entity="editable"
      :org-id="entity.organizationId"
      :user-ids="memberIds"
      :is-submitting="isSaving"
      :teamId="teamId"
      @save="saveEdits"
      @cancel="cancelEdits"
    ></ownership-editor>
  </div>
</template>

<script>
import showAPIError from '@/utils/showAPIError'
import OwnershipEditor from './OwnershipEditor'
import UserShort from './UserShort'

export default {
  name: 'OwnershipViewer',
  components: {
    UserShort,
    OwnershipEditor
  },
  props: ['entity', 'entityType', 'shouldEdit'],
  data() {
    return {
      editing: this.shouldEdit,
      editable: {
        ownerId: null,
        coOwnerIds: []
      },
      /*
        parentEntity is parent-most entity.
        E.g: for kr and initiative it is goal. For idea, it is ideaList
      */
      parentEntity: null,
      isSaving: false
    }
  },
  computed: {
    orgId() {
      return this.entity.organizationId
    },
    teamId() {
      return this.entity.teamId
    },
    owner() {
      let entity = this.entity
      if (entity.ownerId) {
        return this.$store.getters.userById(entity.ownerId)
      } else {
        return null
      }
    },
    memberships() {
      if (!this.teamId) return []
      return this.$store.getters.teamMemberships(this.teamId)
    },
    memberIds() {
      return this.memberships.map(membership => membership.user.id)
    }
  },
  methods: {
    async updateMemberships() {
      this.$store.dispatch('getTeamMemberships', {
        orgId: this.orgId,
        teamId: this.teamId
      })
    },
    editOwners() {
      this.editable = {
        ownerId: this.entity.ownerId,
        coOwnerIds: this.entity.coOwnerIds.slice()
      }
      this.updateMemberships()
      this.editing = true
    },
    async saveEdits() {
      try {
        this.isSaving = true
        const updatedEntity = await this.$store.dispatch('changeOwnership', {
          orgId: this.orgId,
          entityType: this.entityType,
          entity: this.entity,
          ownerId: this.editable.ownerId,
          coOwnerIds: this.editable.coOwnerIds
        })
        this.editing = false
        this.$emit('save', updatedEntity)
      } catch (e) {
        showAPIError(e)
      }
      this.isSaving = false
    },
    cancelEdits() {
      this.editing = false
      this.$emit('cancel')
    }
  },
  mounted() {},
  watch: {
    editing(value) {
      this.$emit('update:shouldEdit', value)
    },
    shouldEdit(edit) {
      if (edit) this.editOwners()
      else this.cancelEdits()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom';
@import '~@/styles/_styleConfigurations.scss';

.ownership-editor {
  width: $popover-max-width - 40px;
}

.ownership-viewer {
  padding-left: 4px;
  padding-right: 4px;
}

.ownership-section:not(:first-child) {
  padding-top: 18px;
}

.ownership-section:last-child {
  padding-bottom: 10px;
}

.ownership-section-title {
  font-size: 13px;
}

.ownership-section-content {
  font-size: 14px;
  color: #4d4d4d;
}

/deep/ .user-short-container {
  padding-top: 5px;
}

.manage-owners-button {
  font-size: 14px;
  color: #333333;
  text-decoration: underline;
  padding-left: 0;
}
</style>
